import { BundlesQuery } from './graphql/api/graphql';
import subscriptionBundleNames from './subscriptionBundleNames';

export interface FormattedBundlePrices {
  monthly: string;
  annual: string;
  annualSavings: string;
  annualMonthlyEquivalent: string;
}

const placeholder: FormattedBundlePrices = {
  monthly: '_',
  annual: '_',
  annualSavings: '_',
  annualMonthlyEquivalent: '_',
};

const formatBundlePrices = (
  data: BundlesQuery | undefined,
  locale: string,
): FormattedBundlePrices => {
  if (!data?.bundles) {
    return placeholder;
  }

  const monthlyBundle = data.bundles.find(
    ({ name }) => name === subscriptionBundleNames.monthly,
  );
  const yearlyBundle = data.bundles.find(
    ({ name }) => name === subscriptionBundleNames.yearly,
  );

  const monthlyAmount = monthlyBundle?.price.amount;
  const annualAmount = yearlyBundle?.price.amount;
  const currency = monthlyBundle?.price.currency;

  if (!monthlyAmount || !annualAmount || !currency) {
    return placeholder;
  }

  const monthly = Number(monthlyAmount);
  const annual = Number(annualAmount);

  const formatter = new Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });

  return {
    monthly: formatter.format(monthly),
    annual: formatter.format(annual),
    annualSavings: formatter.format(monthly * 12 - annual),
    annualMonthlyEquivalent: formatter.format(annual / 12),
  };
};

export default formatBundlePrices;
